<template>
  <div>
    <v-container id="search-container">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
      <v-form v-model="valid" lazy-validation>
        <v-row dense>
          <p class="mb-0 font-weight-bold">
            Enter search criteria. No criteria returns ALL records (may take a
            little while)
          </p>
        </v-row>
        <v-row dense>
          <v-col cols="12" v-if="picker_show">
            <div class="d-flex flex-column">
              <v-date-picker v-model="sterm.dates" range></v-date-picker>
              <v-btn @click="toggle_picker" text>Close</v-btn>
            </div>
          </v-col>
          <v-col cols="12" v-if="picker_show == false">
            <v-text-field
              v-model="dateRangeText"
              label="Date Range (click to change)"
              prepend-icon="mdi-calendar"
              readonly
              @click="toggle_picker"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <p class="my-0 font-weight-bold">Filter by</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.team"
              :items="['CAO', 'MET1', 'MET2', 'CORE']"
              label="TEAM"
              background-color="#ECEFF1"
              multiple
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-col cols="12" class="my-0 py-0">
            <v-autocomplete
              attach
              v-model="sterm.email"
              :items="lst_email"
              label="Records created by"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.area"
              :items="area_items"
              label="Area"
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row>
        <!-- <v-row dense no-gutters>
          <v-col cols="12">
            <v-select
              attach
              v-model="sterm.mission"
              :items="mission_types"
              label="Misson"
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row> -->
        <v-row id="rowaddflds" dense no-gutters>
          <v-col cols="12" md="12">
            <div class="d-flex">
              <v-select
                attach
                :items="items_stat_fields"
                :item-text="'name'"
                :item-value="value"
                label="Fields to Search By"
                solo
                v-model="selected_stat_fields"
              ></v-select>
              <v-btn class="mt-2 ml-3" color="success" @click="add_field"
                >ADD</v-btn
              >
            </div>
          </v-col>
        </v-row>
        <h4 v-if="lst_fields.length > 0">Also Filter By...</h4>
        <v-row id="allfieldsrow" dense no-gutters>
          <v-col cols="12" md="12">
            <div class="text-center">
              <v-chip
                v-for="fld in lst_fields"
                :key="fld"
                color="blue"
                text-color="white"
                class="ma-2"
                close
                @click="remove_field(fld)"
                @click:close="remove_field(fld)"
              >
                {{ fld }}
              </v-chip>
            </div>
          </v-col>
        </v-row>

        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <!-- viusible only on phones -->
            <div class="hide-if-large d-flex justify-space-around align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
            <!-- visble on everything but phones -->
            <div class="hide-if-small d-flex justify-center align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="bReady_to_update">
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn color="cmpbk" class="mr-4 white--text" @click="search">
              Search
            </v-btn>
            <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
              Clear Form
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#chk-all.v-icon.v-icon {
  color: white !important;
}
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  // .hide-if-large {
  //   display: none !important;
  // }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 40%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}
select {
  -webkit-appearance: listbox !important;
  appearance: listbox !important;
}
</style>

<script>
/* eslint-disable */
import { mdiSelectionEllipseArrowInside } from "@mdi/js";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "search",
  mixins: [bus_common],
  props: ["update_search_results"],
  //search data
  data() {
    return {
      picker_show: false,
      lst_fields: [],
      selected_stat_fields: "",
      items_stat_fields: [
        { name: "Planned Operations", value: "planned_operations" },
        { name: "CFS Handled/ Citizen hail", value: "cfs_handled" },
        { name: "Felony Arrests", value: "felony_arrests" },
        { name: "Gross Misdemeanor Arrests", value: "gf_arrests" },
        { name: "Misdemeanor Arrests", value: "misdo_arrests" },
        { name: "Misdemeanor RMC Citations (Criminal)", value: "rmc_cites" },
        { name: "Traffic Stops", value: "traffic_stops" },
        { name: "Traffic Citations (Civil)", value: "traffic_citations" },
        { name: "Warnings ", value: "warnings" },
        { name: "Area Check", value: "area_check" },
        { name: "Business Check", value: "business_check" },
        { name: "Business Contacts", value: "bus_contacts" },
        { name: "Citizen Contacts", value: "citizen_contacts" },
        { name: "Unsheltered Contacts", value: "unsheltered_contacts" },
        { name: "Outreach Offered", value: "deeds_outreach" },
        { name: "Outreach Accepted", value: "deeds_outreach_accepted" },
        { name: "Controlled Substances Seized", value: "substances_seized" },
        { name: "Firearms Seized", value: "firearms_seized" },
        { name: "CPTEDs", value: "cpted" },
        { name: "Inspections", value: "motel_inspections" },
        { name: "Vehicles Posted", value: "vehicle_posted" },
        { name: "Vehicles Towed", value: "vehicle_towed" },
        { name: "Help Tickets", value: "help_tickets" },
        { name: "Service Request", value: "service_request" },
      ],
      rawdata: {},
      lst_email: [],
      values: [],
      lst_users: [],
      bReady_to_update: true,
      valid: true,
      daterule: [
        (v) =>
          v == "" ||
          (new Date(v) !== "Invalid Date" && !isNaN(new Date(v))) ||
          "Must be a valid date.",
      ],
      types: ["All", "Traffic", "Warrant", "Dispatch", "Complaint"],
      area_items: [
        "All",
        "BID",
        "DEEDS",
        "Downtown Corridor",
        "City of Reno",
        "Other",
      ],
      mission_types: [
        "All",
        "DID Operation (ex: 4th street saturation Op/ Shopping Cart Op/ UC op)",
        "Area Check",
        "Ambassador Assist",
        "Business Check",
        "Call for Service",
        "Camp Cleanup",
        "City Walk",
        "Service Request",
        "Warrant Sweep",
        "Motel Inspection",
        "CPTED",
        "Other",
      ],
      sterm: {
        team: "",
        dates: [],
        area: "All",
        other_area: "",
        mission: "All",
        other_mission: "",
        all: false,
        email: "",
      },
      sterm_new: {
        dates: [],
        team: "",
        area: "All",
        other_area: "",
        mission: "All",
        other_mission: "",
        all: false,
        email: "",
      },
    };
  },
  watch: {
    update_search_results: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.bReady_to_update && val != null) {
          this.search();
        }
      },
    },
  },
  computed: {
    dateRangeText() {
      this.mrbreakpoint();
      if (this.sterm.dates[0] == undefined) {
        return (
          this.format_date_us(new Date()) +
          "~" +
          this.format_date_us(new Date())
        );
      }
      return (
        this.format_date_us(new Date(this.sterm.dates[0])) +
        "~" +
        this.format_date_us(new Date(this.sterm.dates[1]))
      );
    },
    hours() {
      var hrs = [];
      hrs.push("None");
      for (let i = 1; i < 24; i++) {
        hrs.push((i * 100).toString().padStart(4, "0"));
      }
      return hrs;
    },
    days() {
      var dys = [];
      dys.push("None");
      for (let i = 0; i < 120; i++) {
        var today = new Date();
        today.setDate(today.getDate() - i);
        var x = this.format_date_us(today);
        dys.push(x);
      }
      return dys;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
  },
  methods: {
    toggle_picker() {
      this.picker_show = !this.picker_show;
    },
    remove_field(str) {
      console.log("remove_field " + str);
      this.removeStringFromArray(this.lst_fields, str);
    },
    add_field() {
      this.lst_fields.push(this.selected_stat_fields);
      this.selected_stat_fields = "";
    },
    message1() {
      alert("This button does nothing yet.");
    },
    reset() {
      this.lst_fields = [];
      this.sterm = this.mno(this.sterm_new);
      this.$emit("search_clear");
    },
    search() {
      //this.show_loader(true);
      console.log("search", this.sterm);
      //make new objet
      let sterm = this.mno(this.sterm);
      sterm.dates = this.dateRangeText;
      if (this.sterm.team.length > 0) {
        sterm.team = this.sterm.team.join("|");
      } else {
        sterm.team = "";
      }
      sterm.lst_fields = this.lst_fields.join("|");

      this.$emit("search", sterm);
      this.$emit("open_search_results");
    },
    init() {
      //  this.mrbreakpoint("init");
      this.sterm = this.mno(this.sterm_new);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_destinct_s_users";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.rawdata = data;
          this.lst_users = this.mno(data);
          this.lst_email = this.mno(this.lst_users);
          this.values = this.mno(this.lst_users);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_users", msg, "error", null, null);
        });

      // this.sterm.dates.push(this.format_date_sql(new Date()));
      // this.sterm.dates.push(this.format_date_sql(new Date()));

      //getDates_boundry

      // var formIn2 = {};
      // formIn2.email = this.$store.state.user.email;
      // formIn2.token = this.$store.state.user.token;
      // formIn2.apiname = "getDates_boundry";
      // var self = this;
      // this.$store
      //   .dispatch("anyapi", formIn2)
      //   .then((data) => {
      //     var date_bndry = { frm_date: data.frm_date, to_date: data.to_date };
      //     self.$store.commit("set_dates_boundry", self.mno(date_bndry));
      //     self.bReady_to_update = true;
      //     console.log("seachr ready");
      //   })
      //   .catch((msg) => {
      //     self.dialog = false;
      //     this.show_loader(false);
      //     this.swall_it("Error lst_users", msg, "error", null, null);
      //   });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
